export default {"src":"https://fishbrain.com/_next/static/media/alabama.377f9f08.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};